import { render, staticRenderFns } from "./MediaDownloadColumn.vue?vue&type=template&id=080ed4d2&scoped=true&"
import script from "./MediaDownloadColumn.vue?vue&type=script&lang=ts&"
export * from "./MediaDownloadColumn.vue?vue&type=script&lang=ts&"
import style0 from "./MediaDownloadColumn.vue?vue&type=style&index=0&id=080ed4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ed4d2",
  null
  
)

export default component.exports